import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import CallToAction from "@/components/CallToAction";
import Footer from "@/components/Footer";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import HowItWorks from "@/components/HowItWorks";
import SplitSection from "@/components/SplitSection";
import Loader from "@/components/Loader";
import NewsletterSignup from "@/components/NewsletterSignup";
import { fetchPageContent } from "@/api/apis";

const Index = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [showLoader, setShowLoader] = useState(true);

  // Animation refs for each section with enhanced options
  const [howItWorksRef, howItWorksInView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
    rootMargin: "-50px 0px",
  });

  const [splitSectionRef, splitSectionInView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
    rootMargin: "-50px 0px",
  });

  const [ctaRef, ctaInView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
    rootMargin: "-50px 0px",
  });

  //////

  const [content, setContent] = useState(null);

  useEffect(() => {
    fetchPageContent("home").then((res) => {
      const sections = [
        "head_banner",
        "how_works",
        "creators_features",
        "businesses_features",
      ];
      const sectionsData: any = {};

      Object.keys(res.data.content).map((fieldKey) => {
        const fieldSection = sections.find((sec) => fieldKey.includes(sec));

        if (fieldSection) {
          sectionsData[fieldSection] = {
            ...(sectionsData[fieldSection] || {}),
            [fieldKey.replace(fieldSection + "_", "")]:
              res.data.content[fieldKey],
          };
        }
      });

      setContent(sectionsData);

      setShowLoader(false);
      setIsLoaded(true);
    });
  }, []);


  return (
    <>
      <Loader isVisible={showLoader} />
      {content && (
        <div
          className={`min-h-screen bg-musicBlack transition-opacity duration-1000 ${
            isLoaded ? "opacity-100" : "opacity-0"
          }`}
        >
          <Header linkColor="white" />
          <main className="relative">
            {/* Hero Section */}
            <Hero content={content.head_banner} />

            {/* How It Works Section */}
            <div
              ref={howItWorksRef}
              className={`how-works-section transition-all duration-1000 relative ${
                howItWorksInView ? "opacity-100" : "opacity-0"
              }`}
              style={{
                transform: howItWorksInView
                  ? "translateY(0)"
                  : "translateY(20px)",
              }}
            >
              <HowItWorks content={content.how_works} />
            </div>

            {/* Split Section - Contains For Creators and For Businesses sections */}
            <div
              ref={splitSectionRef}
              className={`transition-all duration-1000 relative ${
                splitSectionInView ? "opacity-100" : "opacity-0"
              }`}
            >
              <SplitSection content={{creators_features: content.creators_features, businesses_features: content.businesses_features}} />
            </div>

            {/* CTA Section with new text "Join Music Nation" */}
            <div
              ref={ctaRef}
              className={`transition-all duration-1000 relative ${
                ctaInView ? "opacity-100" : "opacity-0"
              }`}
              style={{
                transform: ctaInView ? "translateY(0)" : "translateY(20px)",
              }}
            >
              <CallToAction invertColor={true} />
            </div>

            {/* Voices of the Community section hidden as requested */}
            <NewsletterSignup />
          </main>
          <Footer />
        </div>
      )}
    </>
  );
};

export default Index;
